import { EntityBase } from "./EntityBase";
import { UnitOfMeasure } from "./UnitOfMeasure";

export class FuelType extends EntityBase {
       name: string = null!;
       isTrackable: boolean = null!;
       isDefault: boolean = null!;
       usesDelivery: boolean = null!;
       facilityBased: boolean = null!;
       trackContracts: boolean = null!;
       isMetered: boolean = null!;
       dividesDay: boolean = null!;
       isActive: boolean = null!;
       carbonFootprintCoof: number = null!;
       MBTU2CoofUnits: number = null!;
       MMBTU2CoofUnitCost: number = null!;
       unitsOfMeasure: UnitOfMeasure[] = null!;
}
